import "./style/LandingPage.css";

function Header() {
  return (
    <header>
      <h1>
        <span style={{ color: "#FF76CE" }}>FECODING</span>
        <span style={{ color: "#94FFD8" }}> QUIZ</span>
      </h1>
      <p>Test your knowledge of programming </p>
    </header>
  );
}

export default Header;
